export default "__VITE_ASSET__8ce9b8a5__"